import { ActionType } from "models/contract/downloadPDF";
import { IResponse } from "models";

export const downloadPDFAction = () => {
  return {
    type: ActionType.CONTRACT_INFORMATION_DOWNLOAD_PDF,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.CONTRACT_INFORMATION_DOWNLOAD_PDF_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IResponse) => {
  return {
    type: ActionType.CONTRACT_INFORMATION_DOWNLOAD_PDF_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.CONTRACT_INFORMATION_DOWNLOAD_PDF_RESET,
  };
};
